"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayHtVoiceLanguage = void 0;
exports.PlayHtVoiceLanguage = {
    Afrikaans: "afrikaans",
    Albanian: "albanian",
    Amharic: "amharic",
    Arabic: "arabic",
    Bengali: "bengali",
    Bulgarian: "bulgarian",
    Catalan: "catalan",
    Croatian: "croatian",
    Czech: "czech",
    Danish: "danish",
    Dutch: "dutch",
    English: "english",
    French: "french",
    Galician: "galician",
    German: "german",
    Greek: "greek",
    Hebrew: "hebrew",
    Hindi: "hindi",
    Hungarian: "hungarian",
    Indonesian: "indonesian",
    Italian: "italian",
    Japanese: "japanese",
    Korean: "korean",
    Malay: "malay",
    Mandarin: "mandarin",
    Polish: "polish",
    Portuguese: "portuguese",
    Russian: "russian",
    Serbian: "serbian",
    Spanish: "spanish",
    Swedish: "swedish",
    Tagalog: "tagalog",
    Thai: "thai",
    Turkish: "turkish",
    Ukrainian: "ukrainian",
    Urdu: "urdu",
    Xhosa: "xhosa",
};
